import { render } from "./BankUpdate.vue?vue&type=template&id=1ae0138c"
import script from "./BankUpdate.vue?vue&type=script&lang=js"
export * from "./BankUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__